// Sentry browser SDK init — runs as the very first line of src/index.tsx.
// CRA exposes env vars via REACT_APP_* prefix at build time. Set REACT_APP_SENTRY_DSN
// in .env.production or via CI to enable shipping. Without a DSN, this is a no-op.
import * as Sentry from "@sentry/react";

const dsn = (typeof process !== "undefined" && process.env && process.env.REACT_APP_SENTRY_DSN) || "";

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || "production",
    release: process.env.REACT_APP_SENTRY_RELEASE || "unknown",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.05"),
    replaysSessionSampleRate: 0,    // session replay off by default — opt-in
    replaysOnErrorSampleRate: 0.1,  // capture session replay only on errors (10%)
    beforeSend(event) {
      if (event.request && event.request.headers) {
        const h: any = event.request.headers;
        ["authorization", "cookie", "x-api-key"].forEach((k) => {
          if (h[k]) h[k] = "[redacted]";
        });
      }
      return event;
    },
    initialScope: { tags: { app: "efone-admin-ui" } },
  });
}
